import { OrdersInfiniteView, OrdersTableView } from '@apps-common/apps/portal/pages/orders/components'
import { MobileViewSwitcher } from '@apps-common/components/common/MobileViewSwitcher'
import { IonPage } from '@ionic/react'

export const OrdersPage = () => (
  <IonPage>
    <MobileViewSwitcher desktopView={<OrdersTableView />} mobileView={<OrdersInfiniteView />} />
  </IonPage>
)
